import axios from 'axios'
import baseURL from "@/main"

export default {
  state: {
    marinePolicies: [],
    marinePolicy: {},
    groupLifePolicies: [],
    groupLifePolicy: {},
    employerLiabilityPolicies: [],
    employerLiabilityPolicy: {},
  },
  mutations: {
    setMarinePolicies(state, payload) {
      state.marinePolicies = payload
    },
    setMarinePolicy(state, obj) {
      state.marinePolicy = obj
    },
    setGroupLifePolicies(state, payload) {
      state.groupLifePolicies = payload
    },
    setGroupLifePolicy(state, obj) {
      state.groupLifePolicy = obj
    },
    setEmployerLiabilityPolicies(state, payload) {
      state.employerLiabilityPolicies = payload
    },
    setEmployerLiabilityPolicy(state, obj) {
      state.employerLiabilityPolicy = obj
    },
  },
  actions: {
    buyMarine({ commit }, marineData) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/marine`,
          data: marineData,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    getMarinePolicies({ commit }) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios.get(`${baseURL}/marine/policy`)
          .then((res) => {
            commit('setMarinePolicies', res.data.data)
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    getGroupLifePolicies({ commit }) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios.get(`${baseURL}/group-life/policy`)
          .then((res) => {
            commit('setGroupLifePolicies', res.data.data)
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    getEmployerLiabilityPolicies({ commit }) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios.get(`${baseURL}/employer-liability/policy`)
          .then((res) => {
            commit('setEmployerLiabilityPolicies', res.data.data)
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    buyGroupLife({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/group-life`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    buyEmployerLiability({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/employer-liability`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    initMarinePayment({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/marine/payment/init`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    verifyMarinePayment({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/marine/payment/verify`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    initGroupLifePayment({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/group-life/payment/init`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    verifyGroupLifePayment({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/group-life/payment/verify`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    initEmployerLiabilityPayment({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/employer-liability/payment/init`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
    verifyEmployerLiabilityPayment({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('startLoading')
        axios({
          url: `${baseURL}/employer-liability/payment/verify`,
          data: data,
          method: 'POST',
        })
          .then((res) => {
            commit('endLoading')
            resolve(res)
          })
          .catch((err) => {
            commit('endLoading')
            reject(err)
          })
      })
    },
  },
}
